@if (soView) {
  <section class="main-content">
    <div class="row mt-4" id="ContentPDF">
      <div class="col-12">
        <div class="card">
          <div class="card-header so-view-header"
            style="background: url('assets/images/so-view-bg1.png'); height: 210px !important;">
            <div class="row w-100 pt-2">
              <div class="col-3">
                <img alt="image" src="assets/images/logo.png" class="header-logo"
                  style="left: 15px; top:15px; position: absolute; width:450px;" />
                </div>
                <div class="col-9">
                  <div class="row text-right mt-4" style="margin-right:-45px;">
                    <div class="col-4">&nbsp;</div>
                    <div class="col-4">
                      <div class="card shadow-sm"
                        style="background-color: #ffffff30 !important; height:170px !important;">
                        <div class="card-body">
                          <div class="col-12">
                            <strong class="warning-color">Address</strong><i
                          class="text-14-px fas fa-home fa-header-custom ms-3"></i>
                        </div>
                        <div class="text-right">
                          {{soView.companyAddressLine1}},
                        </div>
                        <div class="text-right">
                          {{soView.companyAddressLine2}},
                        </div>
                        <div class="text-right">
                          {{soView.companyAddressLine3}}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-4">
                    <div class="card shadow-sm"
                      style="background-color: #ffffff30 !important; height:170px !important;">
                      <div class="card-body">
                        <div class="row">
                          <div class="col-12">
                            <span class="warning-color font-bold">Phone</span><i
                          class="text-14-px fas fa-phone fa-header-custom ms-3"></i>
                          <div class="text-right">
                            {{soView.companyPhoneNumber}}
                          </div>
                        </div>
                      </div>
                      <div class="row mt-2">
                        <div class="col-12 mt-1">
                          <strong class="warning-color">Website Url</strong><i
                        class="text-14-px fas fa-link fa-header-custom ms-3"></i>
                        <div class="text-right">
                          <a [href]="soView.companyUrl">
                            {{soView.companyUrl}}
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="card-body">
        <div class="row mt-3 alert so-show-info-header">
          <div class="col-12">
            <b>Show Name: </b>
            <div>
              <h2 class="text-primary d-inline align-middle m-0">{{soView.showName}}</h2>
              <span class="ms-2 d-inline align-middle text-orange">[{{soView.showTags}}]</span>
              <span class="ms-2 d-inline align-middle">[{{soView.showCityName}}/{{soView.showStateName}}]</span>
            </div>
            <!--                            <ng-container *ngIf="soView.showTags; else noTags">-->
            <!--                                  <span *ngFor="let subject of soView.showTags.split('|')"-->
            <!--                                        class="badge badge-pill badge-light" style="font-weight: 100; padding:6px;margin-right:2px;">-->
            <!--                                    {{ subject }}-->
          <!--                                  </span>-->
        <!--                            </ng-container>-->
        <!--                            <ng-template #noTags>-->
        <!--                                <span class="badge badge-pill badge-secondary text-warning">No Show Tag</span>-->
      <!--                            </ng-template>-->
    </div>
    <hr class="title-line mt-2">
  </div>
  <div class="row mt-3">
    <div class="col-3">
      <div class="card shadow-sm border rounded-4 bg-body" size="s" style="background-color: ghostwhite; height: 130px;">
        <div class="card-body pad-10">
          <div class="row">
            <div class="col-7 text-uppercase text-muted small fw-bold mb-2">
              Exhibit House
            </div>
            @if (soView.isBillToExhibitHouse) {
              <div class="col-5">
                <span tuiBadge size="m" appearance="neutral">BILLED TO<span
                class="custom-content"></span></span>
              </div>
            }
          </div>
        </div>
        <div class="card-body pad-10 text-secondary">
          <div class="row mt-3">
            <div class="col-12">
              <strong>{{soView.exhibitHouseName}}</strong>
              @if (!soView.isExhibitHouseExist) {
                <span tuiBadge size="xl" appearance="neutral"
                  style="font-weight: bold;" class="tui-space_right-2">{{ NATEXT }}
                  <span class="custom-content"></span>
                </span>
              }
            </div>
          </div>
          <div class="row">
            <div class="col-12 mt-1 text-right">
              @if (soView.clientEHIsPlatinum) {
                <span tuiBadge size="l" appearance="info"
                  style="font-weight: bold;" class="tui-space_right-2">Platinum
                </span>
              }
              @if (soView.clientEHIsCritical) {
                <span tuiBadge size="l" appearance="negative"
                  style="font-weight: bold;" class="tui-space_right-2">Focus
                </span>
              }
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-3">
      <div class="card shadow-sm border rounded-4 bg-body" size="s" style="background-color: #5d545f0a; height: 130px;">
       <div class="card-body pad-10">
            <div class="row">
            <div class="col-8 text-uppercase text-muted small fw-bold mb-2">
              Exhibitor
            </div>
            @if (soView.isBillToExhibitor) {
              <div class="col-4 primary-color">
                <span tuiBadge appearance="neutral">BILLED<span
                class="custom-content"></span></span>
              </div>
            }
          </div>
          <div class="row mt-3">
            <div class="col-12">
              <strong>{{soView.exhibitorName}}</strong>
              @if (!soView.isExhibitorExist) {
                <span tuiBadge size="m" appearance="neutral"
                  >{{ NATEXT }}<span
                class="custom-content"></span></span>
              }
            </div>
          </div>
          <div class="row">
            <div class="col-12 mt-3 text-right">
              @if (soView.clientEIsDiamond) {
                <span tuiBadge size="l" appearance="info"
                  style="font-weight: bold;" class="tui-space_right-2">Diamond
                </span>
              }
              @if (soView.clientEIsCritical) {
                <span tuiBadge size="l" appearance="negative"
                  style="font-weight: bold;" class="tui-space_right-2">Focus
                </span>
              }
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-3">
      <div class="card shadow-sm border rounded-4 bg-body" size="s" style="background-color: ghostwhite; height: 130px;">
        <div class="card-body pad-10 text-secondary">
          <div class="text-uppercase text-muted small fw-bold mb-2">
          <div class="row">
            <div class="col-12">
              Booth Details
            </div>
          </div>
        </div>
          @if (soView.boothNumber) {
            <div class="row mt-1">
              <div class="col-12">
                <span tuiBadge style="font-weight: bold;" size="l" appearance="info"
                 >{{ soView.boothNumber }}<span class="custom-content">Booth #
                &nbsp;</span></span>
              </div>
            </div>
          }
          <div class="row mt-3">
            @if (soView.isBoothDimensionApply) {
              <div class="col-12">
                <span tuiBadge size="l" appearance="neutral" class="so-view-info me-3">W
                  <span class="custom-content"></span>
                </span>
                <span tuiBadge size="l" appearance="info"
                  class="so-view-info me-3">{{ soView.boothWidth }}
                  <span class="custom-content"></span>
                </span>
                x
                <span tuiBadge size="l" appearance="neutral"
                  class="so-view-info me-3 ms-3">L
                  <span class="custom-content"></span>
                </span>
                <span tuiBadge size="l" appearance="info"
                  class="so-view-info me-3">{{ soView.boothLength }}
                  <span class="custom-content"></span>
                </span>
                x
                <span tuiBadge size="l" appearance="neutral"
                  class="so-view-info me-3 ms-3">H
                  <span class="custom-content"></span>
                </span>
                <span tuiBadge size="l" appearance="info"
                  class="so-view-info">{{ soView.boothHeight }}
                  <span class="custom-content"></span>
                </span>
              </div>
            }
            <!--                                        <div class="col-3" *ngIf="soView.isBoothDimensionApply">-->
            <!--                                            -->
          <!--                                        </div>-->
          <!--                                        <div class="col-3" *ngIf="soView.isBoothDimensionApply">-->
          <!--                                            -->
        <!--                                        </div>-->
        @if (!soView.isBoothDimensionApply) {
          <div class="col-6 mt-2">
            <strong class="warning-color">Booth Dimension</strong>
          </div>
        }
        @if (!soView.isBoothDimensionApply) {
          <div class="col-6">
            <span tuiBadge size="xl" appearance="neutral" style="font-weight: bold;"
              class="tui-space_right-2">{{ NATEXT }}
              <span class="custom-content"></span>
            </span>
          </div>
        }
      </div>
    </div>
  </div>
</div>
<div class="col-3">
  <div class="card shadow-sm border rounded-4 bg-body" size="s" style="background-color: #5d545f0a; height: 130px;">
    <div class="card-body pad-10 text-secondary">
      <div class="text-uppercase text-muted small fw-bold mb-2">
      <div class="row">
        <div class="col-8">
          Service Order
        </div>
        <div class="col-4">
          <span tuiBadge size="m" appearance="primary"
            class="so-view-info">{{ soView.serviceOrderVersionDisplay }}
            <span class="custom-content"></span>
          </span>
        </div>
      </div>
    </div>
      <div class="row">
        <div class="col-12 pt-1">
          <span tuiBadge size="l" appearance="info" style="font-weight: bold;"
            class="tui-space_right-2">{{ soView.serviceOrderFullNumber }}
            <span class="custom-content">SO # &nbsp;</span>
          </span>
          <span tuiBadge size="l" appearance="neutral"
            style="font-weight: bold;padding-left: 8px !important;"
            class="tui-space_right-2">{{ soView.poNumber }}
            <span class="custom-content">PO # &nbsp;</span>
          </span>
        </div>
        <div class="col-12 mt-3 text-normal-size">
          <b>Date created (version:{{soView.serviceOrderVersionDisplay}})</b>
          <div>
            {{soView.serviceOrderCreatedDate | date:
            DAY_NAME_MONTH_DAY_YEAR_AM_PM}}
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</div>
<div class="row mt-3">
  <div class="col-4">
    <div class="card shadow-sm border rounded-4 bg-body" size="s" style="background-color: ghostwhite; height: 170px;">
      <div class="card-body pad-10 text-secondary">
          <div class="text-uppercase text-muted small fw-bold mb-2">
        <div class="row">
          <div class="col-8">
            Show Details
          </div>
        </div>
      </div>
        <div class="row">
          <div class="col-12">
            <strong>Show Dates</strong>
          </div>
        </div>
        <div class="row mt-1">
          <div class="col-6">
            {{soView.showStartDate | date: DAY_NAME_MONTH_DAY_YEAR}}
          </div>
          <div class="col-6">
            {{soView.showEndDate | date: DAY_NAME_MONTH_DAY_YEAR}}
          </div>
        </div>
        <hr class="title-line mt-1">
        <div class="row mt-2">
          <div class="col-12">
            <strong> {{soView.showCityName}},
            {{soView.showStateName}}</strong>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="col-4">
    <div class="card shadow-sm border rounded-4 bg-body" size="s" style="background-color: #5d545f0a; height: 170px;">
      <div class="card-body text-secondary">
         <div class="text-uppercase text-muted small fw-bold mb-2">
        <div class="row">
          <div class="col-12">
            Venue
          </div>
        </div>
      </div>
        <div class="col-12">
          <strong>{{soView.venueName}}</strong>
        </div>
        @if (soView.venueName) {
          <div class="col-12">
            <div class="mt-1 tui-text_body">
              {{soView.venueStreet}}
            </div>
            <div class="mt-1 tui-text_body">
              <strong>{{soView.venueCityName}}, {{soView.venueStateName}}, </strong>
              {{soView.venueZipCode}}
            </div>
            <div class="mt-1 tui-text_body">
              <strong>{{soView.venueCountryName}}</strong>
            </div>
          </div>
        }
        @if (!soView.venueName) {
          <p>
            <strong class="warning-color">{{NATEXT}}</strong>
          </p>
        }
      </div>
    </div>
  </div>
  <div class="col-4">
    <div class="card shadow-sm border rounded-4 bg-body" size="s" style="background-color: ghostwhite; height: 170px;">
      <div class="card-body pad-10">
         <div class="text-uppercase text-muted small fw-bold mb-2">
        <div class="row">
          <div class="col-12">
            Supervision
          </div>
        </div>
      </div>
        <div class="col-12">
          <table class="table table-bordered table-sm mt-2">
            <thead class="">
              <tr>
                <td class="bg-secondary" style="width: 60%;"></td>
                <td class="bg-secondary" style="width: 20%;text-align: center;">
                Install</td>
                <td class="bg-secondary" style="width: 20%;text-align: center;">
                Dismantle</td>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>{{getCompanyName()}}</td>
                <td class="supervision-check-mark">@if (soView.isInstallCompany) {
                  <i class="fas fa-check"
                  ></i>
                }</td>
                <td class="supervision-check-mark">@if (soView.isDismCompany) {
                  <i class="fas fa-check"
                  ></i>
                }</td>
              </tr>
              <tr>
                <td>Exhibitor</td>
                <td class="supervision-check-mark">@if (soView.isInstallExhibitor) {
                  <i class="fas fa-check"
                  ></i>
                }</td>
                <td class="supervision-check-mark">@if (soView.isDismExhibitor) {
                  <i class="fas fa-check"
                  ></i>
                }</td>
              </tr>
              <tr>
                <td>Exhibit House</td>
                <td class="supervision-check-mark">@if (soView.isInstallExhibitHouse) {
                  <i class="fas fa-check"
                  ></i>
                }</td>
                <td class="supervision-check-mark">@if (soView.isDismExhibitHouse) {
                  <i class="fas fa-check"
                  ></i>
                }</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="row mt-3">
  <div class="col-12">
    <div class="card shadow-sm border rounded-4 bg-body" size="s">
      <div class="card-body pad-10">
         <div class="text-uppercase text-muted small fw-bold mb-2">
        <div class="row">
          <div class="col-12">
            Exhibit House Details
            @if (soView.isBillToExhibitHouse) {
              <span class="primary-color">
                <span tuiBadge size="m" appearance="neutral">BILLED TO</span>
              </span>
            }
          </div>
        </div>
      </div>
        @if ((soView?.exhibitHouseAddresses?.length ?? 0) > 0) {
          <div class="col-12">
            <table class="table table-bordered table-sm">
              <thead>
                <tr>
                  <td class="bg-secondary" style="width: 30%;">Company Name</td>
                  <td class="bg-secondary" style="width: 10%;">Office Contact</td>
                  <td class="bg-secondary" style="width: 30%;">Street</td>
                  <td class="bg-secondary" style="width: 5%;">Zip Code</td>
                  <td class="bg-secondary" style="width: 10%;">City</td>
                  <td class="bg-secondary" style="width: 10%;">State</td>
                  <td class="bg-secondary" style="width: 5%;">Country</td>
                </tr>
              </thead>
              <tbody>
                @for (item of soView.exhibitHouseAddresses; track item) {
                  <tr>
                    <td>
                      {{item.clientName}}
                    </td>
                    <td class="text-14-px">
                      @if (item.phoneNumber) {
                        <span>
                          {{item.phoneNumber| phoneFormat:
                        getDialCode(item.phoneDialCode):'(###) ###-####'}}</span>
                      }
                    </td>
                    <td>
                      {{item.street}}
                    </td>
                    <td>
                      {{item.zipCode}}
                    </td>
                    <td>
                      {{item.cityName}}
                    </td>
                    <td>
                      {{item.stateName}}
                    </td>
                    <td>
                      {{item.countryName}}
                    </td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
        }
        @if (soView.exhibitHouseAddresses.length === 0) {
          <div class="col-12 text-center">
            <hr class="title-line mt-2 mb-2">
            <span tuiBadge size="xl" appearance="negative" style="font-weight: bold;"
              class="tui-space_right-2">{{ NATEXT }}
              <span class="custom-content"></span>
            </span>
          </div>
        }
      </div>
    </div>
  </div>
</div>
<div class="row mt-3">
  <div class="col-12">
    <div class="card shadow-sm border rounded-4 bg-body" size="s">
      <div class="card-body pad-10">
        <div class="text-uppercase text-muted small fw-bold mb-2">
        <div class="row">
          <div class="col-12">
            Exhibitor Details
            @if (soView.isBillToExhibitor) {
              <span class="primary-color">
                <span tuiBadge size="m" appearance="neutral">BILLED TO</span>
              </span>
            }
          </div>
        </div>
      </div>
        @if (soView.exhibitorAddresses.length > 0) {
          <div class="col-12">
            <table class="table table-bordered table-sm">
              <thead>
                <tr>
                  <td class="bg-secondary" style="width: 30%;">Company Name</td>
                  <td class="bg-secondary" style="width: 10%;">Office Contact</td>
                  <td class="bg-secondary" style="width: 30%;">Street</td>
                  <td class="bg-secondary" style="width: 5%;">Zip Code</td>
                  <td class="bg-secondary" style="width: 10%;">City</td>
                  <td class="bg-secondary" style="width: 10%;">State</td>
                  <td class="bg-secondary" style="width: 5%;">Country</td>
                </tr>
              </thead>
              <tbody>
                @for (item of soView.exhibitorAddresses; track item) {
                  <tr>
                    <td>
                      {{item.clientName}}
                    </td>
                    <td class="text-14-px">
                      @if (item.phoneNumber) {
                        <span>
                          {{item.phoneNumber| phoneFormat:
                        getDialCode(item.phoneDialCode):'(###) ###-####'}}</span>
                      }
                    </td>
                    <td>
                      {{item.street}}
                    </td>
                    <td>
                      {{item.zipCode}}
                    </td>
                    <td>
                      {{item.cityName}}
                    </td>
                    <td>
                      {{item.stateName}}
                    </td>
                    <td>
                      {{item.countryName}}
                    </td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
        }
        @if (soView.exhibitorAddresses.length === 0) {
          <div class="col-12">
            <span tuiBadge appearance="negative">{{ NATEXT }}</span>
          </div>
        }
      </div>
    </div>
  </div>
</div>
<div class="row mt-3">
  <div class="col-12">
    <div class="card shadow-sm border rounded-4 bg-body" size="s">
      <div class="card-body pad-10">
        <div class="text-uppercase text-muted small fw-bold mb-2">
        <div class="row">
          <div class="col-12">
            Exhibit House Contacts
          </div>
        </div>
      </div>
        @if (soView.exhibitHouseContacts.length > 0) {
          <div class="col-12">
            <table class="table table-bordered table-sm">
              <thead>
                <tr>
                  <td class="bg-secondary" style="width: 15%;">First Name</td>
                  <td class="bg-secondary" style="width: 15%;">Last Name
                  </td>
                  <td class="bg-secondary" style="width: 20%;">Email
                  </td>
                  <td class="bg-secondary" style="width: 20%;">Role
                  </td>
                  <td class="bg-secondary" style="width: 15%;">Mobile
                  </td>
                  <td class="bg-secondary" style="width: 15%;">Office Contact
                  </td>
                </tr>
              </thead>
              <tbody>
                @for (item of soView.exhibitHouseContacts; track item) {
                  <tr>
                    <td>
                      {{item.firstName}}
                    </td>
                    <td>
                      {{item.lastName}}
                    </td>
                    <td>
                      {{item.email}}
                    </td>
                    <td>
                      {{item.roleName}}
                    </td>
                    <td>
                      @if (item.mobileNumber) {
                        <span>
                          {{item.mobileNumber| phoneFormat:
                          getDialCode(item.mobileNumberDialCode):'(###)
                        ###-####'}}</span>
                      }
                    </td>
                    <td>
                      @if (item.officePhoneNumber) {
                        <span>
                          {{item.officePhoneNumber| phoneFormat:
                          getDialCode(item.officePhoneNumberDialCode):'(###)
                        ###-####'}}</span>
                      }
                    </td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
        }
        @if (soView.exhibitHouseContacts.length === 0) {
          <div class="col-12">
            <span tuiBadge appearance="negative">{{ NATEXT }}</span>
          </div>
        }
      </div>
    </div>
  </div>
</div>
@if (soView.exhibitorContacts.length > 0) {
  <div class="row mt-3">
    <div class="col-12">
      <div class="card shadow-sm border rounded-4 bg-body">
        <div class="card-body pad-10">
          <div class="text-uppercase text-muted small fw-bold mb-2">
          <div class="row">
            <div class="col-12">
              Exhibitor Contacts
            </div>
          </div>
        </div>
          <div class="col-12">
            <table class="table table-bordered table-sm">
              <thead>
                <tr>
                  <td class="bg-secondary" style="width: 15%;">First Name</td>
                  <td class="bg-secondary" style="width: 15%;">Last Name
                  </td>
                  <td class="bg-secondary" style="width: 20%;">Email
                  </td>
                  <td class="bg-secondary" style="width: 20%;">Role
                  </td>
                  <td class="bg-secondary" style="width: 15%;">Mobile
                  </td>
                  <td class="bg-secondary" style="width: 15%;">Office Contact
                  </td>
                </tr>
              </thead>
              <tbody>
                @for (item of soView.exhibitorContacts; track item) {
                  <tr>
                    <td>
                      {{item.firstName}}
                    </td>
                    <td>
                      {{item.lastName}}
                    </td>
                    <td>
                      {{item.email}}
                    </td>
                    <td>
                      {{item.roleName}}
                    </td>
                    <td>
                      @if (item.mobileNumber) {
                        <span>
                          {{item.mobileNumber| phoneFormat:
                          getDialCode(item.mobileNumberDialCode):'(###)
                        ###-####'}}</span>
                      }
                    </td>
                    <td>
                      @if (item.officePhoneNumber) {
                        <span>
                          {{item.officePhoneNumber| phoneFormat:
                          getDialCode(item.officePhoneNumberDialCode):'(###)
                        ###-####'}}</span>
                      }
                    </td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
          @if (soView.exhibitorContacts.length === 0) {
            <div class="col-12">
              <span tuiBadge appearance="negative">{{ NATEXT }}</span>
            </div>
          }
        </div>
      </div>
    </div>
  </div>
}
<div class="row mt-3">
  <div class="col-12">
    <div class="card shadow-sm border rounded-4 bg-body">
      <div class="card-body pad-10">
        <div class="row">
          <div class="col-4">
            <strong class="pad-right-10">Type of Service Order:</strong>
            <span tuiBadge appearance="neutral" class="tui-space_right-2"
           >{{ soView.typeOfServiceOrderDisplayName }}</span>
          </div>
          <div class="col-4">
            <strong class="pad-right-10">Standard Bid:</strong>
            <span tuiBadge appearance="neutral" class="tui-space_right-2"
           >{{ soView.standardBid }}</span>
          </div>
          <div class="col-4">
            <strong class="pad-right-10">Exhibitor Contacts: </strong>@if (soView.exhibitorContacts.length === 0) {
            <span tuiBadge appearance="negative">{{ NATEXT }}</span>
          }
        </div>
      </div>
    </div>
  </div>
</div>
</div>
<div class="row mt-3">
  <div class="col-12">
    <div class="card shadow-sm border rounded-4 bg-body" size="s" style="border: 2px solid #8da58d">
      <div class="text-uppercase text-muted small fw-bold mb-2">
        <div class="row">
          <div class="col-12">
            <table class="table table-bordered table-sm mb-0">
              <tbody>
                <tr>
                  <th style="width: 100%; color: white;" class="bg-positive pad-10 rounded-1">
                    Install Details@if (soView.isDateAssumed) {
                    <strong class="pad-left-10"
                    > (Assumed)</strong>
                  }
                </th>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <div class="card-text text-secondary ">
      <div class="row">
        <div class="col-12">
          <table class="table table-bordered table-sm">
            <thead>
              <tr>
                <th class="bg-secondary">Date</th>
                <th class="bg-secondary text-center">Start Time</th>
                <th class="bg-secondary text-center">End Time</th>
                <th class="bg-secondary text-center">No. of Men</th>
                <th class="bg-secondary text-center">No. of Hours</th>
                <th class="bg-secondary  text-center">Total Hours</th>
                <th class="bg-secondary text-center">Rate Type</th>
                @if (!soView.isPriceHide) {
                  <th class="bg-secondary text-end">
                  Rate $</th>
                }
                @if (!soView.isPriceHide) {
                  <th class="bg-secondary text-end">
                  Sub Total $</th>
                }
              </tr>
            </thead>
            <tbody>
              @for (install of soView.soInstallLabors; track install) {
                <tr>
                  @if (install.noOfHours>0) {
                    <td>{{install.jobDate | date : DT_Format_YYYY_MM_DD}} <span
                      class="text-small-size">{{install.jobDate | date :
                    'EEE'}}</span>
                    @if (install.isWaiveMini) {
                      <code class="pad-left-10"
                      >Waive Mini: {{install.isWaiveMini ? 'Yes':'No'}}</code>
                    }
                  </td>
                  <td class="text-center">
                    {{getTimeAMPM(install.jobStartTime)}}
                  </td>
                  <td class="text-center">{{getTimeAMPM(install.jobEndTime)}}
                  </td>
                  <td class="text-center">{{install.noOfLabors}}</td>
                  <td class="text-center">{{install.noOfHours}}</td>
                  <td class="text-center">{{install.totalHours}}</td>
                  <td class="text-center">@if (install.totalHours===0) {
                    <span
                    >*</span>
                    }@if (install.totalHours>0) {
                    <span
                    >{{install.rateType}}</span>
                  }
                </td>
                @if (!soView.isPriceHide) {
                  <td class="text-end">
                    {{install.rate
                  | number : '1.2-2'}}</td>
                }
                @if (!soView.isPriceHide) {
                  <td class="text-end">
                  {{install.subTotal | number : '1.2-2'}}</td>
                }
              }
            </tr>
          }
        </tbody>
      </table>
    </div>
  </div>
  <div class="row">
    <div class="col-12">
      <table class="table table-bordered table-sm">
        <tbody>
          <tr>
            <td style="width: 70%;"></td>
            <td style="width: 20%;text-align: right;" class="bg-secondary">
            Install Total</td>
            <td style="width: 10%;text-align: right;" class="bg-secondary">$
              {{soView.soInstallLaborsTotalAmount | number : '1.2-2'}}
            </td>
          </tr>
          <tr>
            <td style="width: 70%;"></td>
            <td style="width: 20%;text-align: right;" class="bg-secondary">
              Install Tax ({{soView.installLaborTax | number : '1.2-2'}})%
            </td>
            <td style="width: 10%;text-align: right;" class="bg-secondary">$
            {{soView.soInstallLaborsTaxAmount | number : '1.2-2'}}</td>
          </tr>
          <tr>
            <td style="width: 70%;">
              <span tuiBadge size="l" appearance="primary"
                class="so-view-info">A
                <span class="custom-content"></span>
              </span>
            </td>
            <td style="width: 20%;text-align: right;color: white;"
            class="so-view-cell-summary">Install Total After Tax</td>
            <td style="width: 10%;text-align: right;color: white;"
              class="so-view-cell-summary">$
              {{soView.soInstallLaborsTotalAmountWithTax | number :
              '1.2-2'}}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
</div>
</div>
</div>
<div class="row mt-3">
  <div class="col-12">
    <div class="card shadow-sm border rounded-4 bg-body" size="s" style="border:2px solid #e49c89;">
      <div class="text-uppercase text-muted small fw-bold mb-2">
        <div class="row">
          <div class="col-12">
            <table class="table table-bordered table-sm mb-0">
              <tbody>
                <tr>
                  <th style="width: 100%; color: white;" class="bg-error pad-10 rounded-1">
                    Dismantle Details @if (soView.isDateAssumed) {
                    <strong class="pad-left-10"
                    > (Assumed)</strong>
                  }
                </th>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <div class="card-text text-secondary ">
      <div class="row">
        <div class="col-12">
          <table class="table table-bordered table-sm">
            <thead>
              <tr>
                <th class="bg-secondary">Date</th>
                <th class="bg-secondary text-center">Start Time</th>
                <th class="bg-secondary text-center">End Time</th>
                <th class="bg-secondary text-center">No. of Men</th>
                <th class="bg-secondary text-center">No. of Hours</th>
                <th class="bg-secondary  text-center">Total Hours</th>
                <th class="bg-secondary text-center">Rate Type</th>
                @if (!soView.isPriceHide) {
                  <th class="bg-secondary text-end">
                  Rate $</th>
                }
                @if (!soView.isPriceHide) {
                  <th class="bg-secondary text-end">
                  Sub Total $</th>
                }
              </tr>
            </thead>
            <tbody>
              @for (dismantle of soView.soDismantleLabors; track dismantle) {
                <tr>
                  @if (dismantle.noOfHours>0) {
                    <td>{{dismantle.jobDate| date : DT_Format_YYYY_MM_DD}} <span
                      class="text-small-size text-muted">{{dismantle.jobDate
                      |
                    date : 'EEE'}}</span>
                    @if (dismantle.isWaiveMini) {
                      <code class="pad-left-10"
                      >Waive Mini: {{dismantle.isWaiveMini ? 'Yes':'No'}}</code>
                    }
                  </td>
                  <td class="text-center">
                    {{getTimeAMPM(dismantle.jobStartTime)}}
                  </td>
                  <td class="text-center">
                    {{getTimeAMPM(dismantle.jobEndTime)}}
                  </td>
                  <td class="text-center">{{dismantle.noOfLabors}}</td>
                  <td class="text-center">{{dismantle.noOfHours}}</td>
                  <td class="text-center">{{dismantle.totalHours}}</td>
                  <td class="text-center">@if (dismantle.totalHours===0) {
                    <span
                    >*</span>
                    }@if (dismantle.totalHours>0) {
                    <span
                    >{{dismantle.rateType}}</span>
                  }
                </td>
                @if (!soView.isPriceHide) {
                  <td class="text-end">
                  {{dismantle.rate | number : '1.2-2'}}</td>
                }
                @if (!soView.isPriceHide) {
                  <td class="text-end">
                  {{dismantle.subTotal | number : '1.2-2'}}</td>
                }
              }
            </tr>
          }
        </tbody>
      </table>
    </div>
  </div>
  <div class="row">
    <div class="col-12">
      <table class="table table-bordered table-sm">
        <tbody>
          <tr>
            <td style="width: 70%;"></td>
            <td style="width: 20%;text-align: right;" class="bg-secondary">
            Dismantle Total</td>
            <td style="width: 10%;text-align: right;" class="bg-secondary">$
              {{soView.soDismantleLaborsTotalAmount | number : '1.2-2'}}
            </td>
          </tr>
          <tr>
            <td style="width: 70%;"></td>
            <td style="width: 20%;text-align: right;" class="bg-secondary">
              Dismantle Tax ({{soView.dismantleLaborTax | number :
              '1.2-2'}})%
            </td>
            <td style="width: 10%;text-align: right;" class="bg-secondary">$
              {{soView.soDismantleLaborsTaxAmount | number : '1.2-2'}}
            </td>
          </tr>
          <tr>
            <td style="width: 70%;">
              <span tuiBadge size="l" appearance="primary"
                class="so-view-info">B
                <span class="custom-content"></span>
              </span>
            </td>
            <td style="width: 20%;text-align: right;color: white;"
            class="so-view-cell-summary">Dismantle Total After Tax</td>
            <td style="width: 10%;text-align: right;color: white;"
              class="so-view-cell-summary">$
              {{soView.soDismantleLaborsTotalAmountWithTax | number :
              '1.2-2'}}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
</div>
</div>
</div>
<div class="row mt-3">
  <div class="col-12">
    <div class="card shadow-sm border rounded-4 bg-body" size="s" style="border:2px solid silver;">
      <div class="text-uppercase text-muted small fw-bold mb-2">
        <div class="row bg-light m-0 rounded-1" style="padding: 10px 0;">
          <div class="col-12">
            Show Day Labor
          </div>
        </div>
      </div>
      <div class="card-text text-secondary ">
        <div class="row">
          <div class="col-12">
            <table class="table table-bordered table-sm mb-0">
              <thead>
                <tr>
                  <th class="bg-secondary">Date</th>
                  <th class="bg-secondary text-center">Start Time</th>
                  <th class="bg-secondary text-center">End Time</th>
                  <th class="bg-secondary text-center">No. of Men</th>
                  <th class="bg-secondary text-center">No. of Hours</th>
                  <th class="bg-secondary  text-center">Total Hours</th>
                  <th class="bg-secondary text-center">Rate Type</th>
                  @if (!soView.isPriceHide) {
                    <th class="bg-secondary text-end">
                    Rate $</th>
                  }
                  @if (!soView.isPriceHide) {
                    <th class="bg-secondary text-end">
                    Sub Total $</th>
                  }
                </tr>
              </thead>
              <tbody>
                @for (addlLabors of soView.soAdditionalLabors; track addlLabors) {
                  <tr>
                    @if (addlLabors.noOfHours>0) {
                      <td>{{addlLabors.jobDate| date : DT_Format_YYYY_MM_DD}}
                        <span
                          class="text-small-size text-muted">{{addlLabors.jobDate
                        | date : 'EEE'}}</span>
                        @if (addlLabors.isWaiveMini) {
                          <code class="pad-left-10"
                          >Waive Mini: {{addlLabors.isWaiveMini ? 'Yes':'No'}}</code>
                        }
                      </td>
                      <td class="text-center">
                        {{getTimeAMPM(addlLabors.jobStartTime)}}
                      </td>
                      <td class="text-center">
                        {{getTimeAMPM(addlLabors.jobEndTime)}}
                      </td>
                      <td class="text-center">{{addlLabors.noOfLabors}}</td>
                      <td class="text-center">{{addlLabors.noOfHours}}</td>
                      <td class="text-center">{{addlLabors.totalHours}}</td>
                      <td class="text-center">@if (addlLabors.totalHours===0) {
                        <span
                        >*</span>
                        }@if (addlLabors.totalHours>0) {
                        <span
                        >{{addlLabors.rateType}}</span>
                      }
                    </td>
                    @if (!soView.isPriceHide) {
                      <td class="text-end">
                      {{addlLabors.rate | number : '1.2-2'}}</td>
                    }
                    @if (!soView.isPriceHide) {
                      <td class="text-end">
                      {{addlLabors.subTotal | number : '1.2-2'}}</td>
                    }
                  }
                </tr>
              }
            </tbody>
          </table>
        </div>
      </div>
      @if (!soView.isPriceHide) {
        <div class="row">
          <div class="col-12">
            <table class="table table-bordered table-sm mb-0">
              <tbody>
                <tr>
                  <td style="width: 70%;"></td>
                  <td style="width: 20%;text-align: right;" class="bg-secondary">
                  Additional Total</td>
                  <td style="width: 10%;text-align: right;" class="bg-secondary">$
                    {{soView.soAdditionalLaborsTotalAmount | number : '1.2-2'}}
                  </td>
                </tr>
                <tr>
                  <td style="width: 70%;"></td>
                  <td style="width: 20%;text-align: right;" class="bg-secondary">
                    Additional Tax ({{soView.additionalLaborTax | number :
                    '1.2-2'}})%
                  </td>
                  <td style="width: 10%;text-align: right;" class="bg-secondary">$
                    {{soView.soAdditionalLaborsTaxAmount | number : '1.2-2'}}
                  </td>
                </tr>
                <tr>
                  <td style="width: 70%;">
                    <span tuiBadge size="l" appearance="primary"
                      class="so-view-info">C
                      <span class="custom-content"></span>
                    </span>
                  </td>
                  <td style="width: 20%;text-align: right;"
                  class="so-view-cell-summary">Additional Total After Tax</td>
                  <td style="width: 10%;text-align: right;"
                    class="so-view-cell-summary">
                    ${{soView.soAdditionalLaborsTotalAmountWithTax | number :
                    '1.2-2'}}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      }
    </div>
  </div>
</div>
</div>
@if (!soView.isPriceHide) {
  <div class="row mt-3">
    <div class="col-12">
      <div class="card shadow-sm border rounded-4 bg-body" size="s" class="pad-bottom-10">
        <div class="text-uppercase text-muted small fw-bold mb-2">
          <div class="row">
            <div class="col-1">
              <span tuiBadge size="l" appearance="primary" class="so-view-info">D
                <span class="custom-content"></span>
              </span>
            </div>
            <div class="col-9 text-end">
              <strong class="margin-right-10">
                Total Labor Estimate
              </strong>
              <span tuiBadge size="l" appearance="primary" class="margin-right-10 so-view-info"
               >A
                <span class="custom-content"></span>
              </span>
              <!-- TODO: (Taiga UI migration) For colored icons, please use <img src="'name' | tuiIcon" alt="icon" /> -->
<span tuiAvatar="@tui.plus"  class="so-view-info-plus-minus"></span>
              <span tuiBadge size="l" appearance="primary" class="margin-right-10 so-view-info"
               >B
                <span class="custom-content"></span>
              </span>
              <!-- TODO: (Taiga UI migration) For colored icons, please use <img src="'name' | tuiIcon" alt="icon" /> -->
<span tuiAvatar="@tui.plus"  class="so-view-info-plus-minus"></span>
              <span tuiBadge size="l" appearance="primary" class="margin-right-10 so-view-info"
               >C
                <span class="custom-content"></span>
              </span>
            </div>
            <div class="col-2 text-end pad-top-10">
              $ {{soView.soInstallDismAdditionalTotalAmountWithTax | number :'1.2-2'}}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
}
<div class="row mt-3">
  <div class="col-12">
    <div class="card shadow-sm border rounded-4 bg-body" size="s">
      <div class="card-body pad-10">
           <div class="text-uppercase text-muted small fw-bold mb-2">
        <div class="row">
          <div class="col-12">
            Materials (Estimate Only; Actual Materials Used Will Be Billed)
          </div>
        </div>
      </div>
        <div class="row">
          <div class="col-12">
            <table class="table table-bordered table-sm mb-0">
              <thead class="">
                <tr>
                  <td class="bg-secondary" style="width: 70%;">Material Name</td>
                  @if (!soView.isPriceHide) {
                    <td class="bg-secondary" style="width: 10%;text-align: right;"
                    >Rate/Unit $</td>
                  }
                  <td class="bg-secondary" style="width: 10%;text-align: right;">
                  Quantity</td>
                  @if (!soView.isPriceHide) {
                    <td class="bg-secondary" style="width: 10%;text-align: right;"
                    >Total $</td>
                  }
                </tr>
              </thead>
              <tbody>
                @for (material of soView.soMaterials; track material) {
                  <tr>
                    <td>{{material.materialName}}</td>
                    @if (!soView.isPriceHide) {
                      <td class="text-end">{{material.rate
                      | number : '1.2-2'}}</td>
                    }
                    <td class="text-end">{{material.quantity}}</td>
                    @if (!soView.isPriceHide) {
                      <td class="text-end">
                      {{material.total | number : '1.2-2'}}</td>
                    }
                  </tr>
                }
              </tbody>
            </table>
          </div>
        </div>
        @if (!soView.isPriceHide) {
          <div class="row">
            <div class="col-12">
              <table class="table table-bordered table-sm mb-0">
                <tbody>
                  <tr>
                    <td style="width: 70%;"></td>
                    <td style="width: 20%;text-align: right;" class="bg-secondary">
                    Material Total</td>
                    <td style="width: 10%;text-align: right;" class="bg-secondary">
                    ${{soView.soMaterialTotalAmount | number : '1.2-2'}}</td>
                  </tr>
                  <tr>
                    <td style="width: 70%;"></td>
                    <td style="width: 20%;text-align: right;" class="bg-secondary">
                      Material Sales Tax ({{soView.soMaterialSalesTaxPerc | number
                      : '1.2-2'}})%
                    </td>
                    <td style="width: 10%;text-align: right;" class="bg-secondary">
                    ${{soView.soMaterialTaxAmount | number : '1.2-2'}}</td>
                  </tr>
                  <tr>
                    <td style="width: 70%; ">
                      <span tuiBadge size="l" appearance="primary"
                        class="so-view-info">E
                        <span class="custom-content"></span>
                      </span>
                      @if (soView.isMaterialWaived) {
                        <span tuiBadge size="m"
                          appearance="info"
                          style="font-weight: bold;margin-left: 20px;"
                         
                          class="tui-space_right-2">{{ getMaterialWaivedAmount(soView.soMaterialTotalAmountWithTax) }}
                          <span class="custom-content"></span>
                        </span>
                      }
                    </td>
                    <td style="width: 20%;text-align: right;color: white;"
                    class="so-view-cell-summary">Material Total After Tax</td>
                    <td style="width: 10%;text-align: right;color: white;"
                      class="so-view-cell-summary">
                      ${{soView.soMaterialTotalAmountWithTax | number : '1.2-2'}}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        }
      </div>
    </div>
  </div>
</div>
<div class="row mt-3">
  <div class="col-12">
    <div class="card shadow-sm border rounded-4 bg-body" size="s">
      <div class="card-body pad-10">
         <div class="text-uppercase text-muted small fw-bold mb-2">
        <div class="row">
          <div class="col-12">
            Equipment
          </div>
        </div>
      </div>
        <div class="row">
          <div class="col-12">
            <table class="table table-bordered table-sm mb-0">
              <thead class="">
                <tr>
                  <td class="bg-secondary" style="width: 70%;">Equipment Name</td>
                  @if (!soView.isPriceHide) {
                    <td class="bg-secondary" style="width: 10%;text-align: right;"
                    >Rate/Unit $</td>
                  }
                  <td class="bg-secondary" style="width: 10%;text-align: right;">
                  Quantity</td>
                  @if (!soView.isPriceHide) {
                    <td class="bg-secondary" style="width: 10%;text-align: right;"
                    >Total $</td>
                  }
                </tr>
              </thead>
              <tbody>
                @for (eq of soView.soEquipments; track eq) {
                  <tr>
                    <td>{{eq.equipmentName}}</td>
                    @if (!soView.isPriceHide) {
                      <td class="text-end">{{eq.rate |
                      number : '1.2-2'}}</td>
                    }
                    <td class="text-end">{{eq.quantity}}</td>
                    @if (!soView.isPriceHide) {
                      <td class="text-end">{{eq.total |
                      number : '1.2-2'}}</td>
                    }
                  </tr>
                }
              </tbody>
            </table>
          </div>
        </div>
        @if (!soView.isPriceHide) {
          <div class="row">
            <div class="col-12">
              <table class="table table-bordered table-sm mb-0">
                <tbody>
                  <tr>
                    <td style="width: 70%;">
                      <span tuiBadge size="l" appearance="primary"
                        class="so-view-info">F
                        <span class="custom-content"></span>
                      </span>
                    </td>
                    <td style="width: 20%;text-align: right;color: white;"
                    class="so-view-cell-summary">Equipment Total</td>
                    <td style="width: 10%;text-align: right;color: white;"
                      class="so-view-cell-summary">$
                    {{soView.soEquipmentTotalAmount | number : '1.2-2'}}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        }
      </div>
    </div>
  </div>
</div>
<div class="row mt-3">
  <div class="col-12">
    <div class="card shadow-sm border rounded-4 bg-body">
      <div class="card-body pad-10">
          <div class="text-uppercase text-muted small fw-bold mb-2">
        <div class="row">
          <div class="col-12">
            Additional Items
          </div>
        </div>
      </div>
        <div class="row">
          <div class="col-12">
            <table class="table table-bordered table-sm mb-0">
              <thead class="">
                <tr>
                  <td class="bg-secondary" style="width: 50%;">Item Name</td>
                  <td class="bg-secondary" style="width: 20%;">Description</td>
                  @if (!soView.isPriceHide) {
                    <td class="bg-secondary" style="width: 10%;text-align: right;"
                    >Cost $</td>
                  }
                  <td class="bg-secondary" style="width: 10%;text-align: center;">
                  Taxable</td>
                  @if (!soView.isPriceHide) {
                    <td class="bg-secondary" style="width: 10%;text-align: right;"
                    >Sub Total $</td>
                  }
                </tr>
              </thead>
              <tbody>
                @for (item of soView.soAdditionalItems; track item) {
                  <tr>
                    <td><span class="break-word"> {{item.itemName}}</span></td>
                    <td><span class="break-word">{{item.itemDescription}}</span>
                  </td>
                  @if (!soView.isPriceHide) {
                    <td class="text-end">{{item.itemCost
                    | number : '1.2-2'}}</td>
                  }
                  <td class="text-center">{{item.isTaxable === true?'Yes':'No'}}
                  </td>
                  @if (!soView.isPriceHide) {
                    <td class="text-end">{{item.total |
                    number : '1.2-2'}} </td>
                  }
                </tr>
              }
            </tbody>
          </table>
        </div>
      </div>
      @if (!soView.isPriceHide) {
        <div class="row">
          <div class="col-12">
            <table class="table table-bordered table-sm mb-0">
              <tbody>
                <tr>
                  <td style="width: 70%;">
                    <span tuiBadge size="l" appearance="primary"
                      class="so-view-info">G
                      <span class="custom-content"></span>
                    </span>
                  </td>
                  <td style="width: 20%;text-align: right;color: white;"
                  class="so-view-cell-summary">Item Total</td>
                  <td style="width: 10%;text-align: right;color: white;"
                    class="so-view-cell-summary">
                    ${{soView.soAdditionalItemTotalAmountWithTax | number
                  :'1.2-2'}}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      }
    </div>
  </div>
</div>
</div>
@if (!soView.isPriceHide) {
  <div class="row mt-3">
    <div class="col-12">
      <div class="card shadow-sm border rounded-4 bg-body" size="s" class="pad-bottom-10">
        <div class="card-body pad-10">
           <div class="text-uppercase text-muted small fw-bold mb-2">
          <div class="row">
            <div class="col-12">
              EAC Fee
            </div>
          </div>
        </div>
          <div class="row">
            <div class="col-12">
              <table class="table table-bordered table-sm mb-0">
                <tbody>
                  <tr>
                    <td style="width: 70%;">
                      <span tuiBadge size="l" appearance="primary"
                        class="so-view-info">H
                        <span class="custom-content"></span>
                      </span>
                    </td>
                    <td style="width: 20%;text-align: right;color: white;"
                    class="so-view-cell-summary">EAC Fee Total</td>
                    <td style="width: 10%;text-align: right;color: white;"
                      class="so-view-cell-summary">${{soView.totalEacFee | number
                    : '1.2-2'}}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
}
<div class="row mt-3">
  <div class="col-12">
    <div class="card shadow-sm border rounded-4 bg-body">
    <div class="card-body pad-10">
       <div class="text-uppercase text-muted small fw-bold mb-2">
        <div class="row">
          <div class="col-6">
            Travel Cost
          </div>
          <div class="col-6">
            Travel Cost Required : @if (soView.isTravelCostRequired) {
            <span>Yes</span>
          }
          @if (!soView.isTravelCostRequired) {
            <span>No</span>
          }
        </div>
      </div>
    </div>
      <div class="row">
        <div class="col-12">
          <table class="table table-bordered table-sm mb-0">
            <tbody>
              <tr>
                <td style="width: 70%;">
                  <span tuiBadge size="l" appearance="primary"
                    class="so-view-info">I
                    <span class="custom-content"></span>
                  </span>
                </td>
                <td style="width: 20%;text-align: right;color: white;"
                class="so-view-cell-summary">Travel Total</td>
                <td style="width: 10%;text-align: right;color: white;"
                  class="so-view-cell-summary">$
                  {{soView.travelCost | number :
                '1.2-2'}}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>
</div>
@if (!soView.isPriceHide) {
  <div class="row mt-3">
    <div class="col-12">
      <div class="card shadow-sm border rounded-4 bg-body" size="s" class="pad-bottom-10">
        <div class="card-body pad-10">
           <div class="text-uppercase text-muted small fw-bold mb-2">
          <div class="row">
            <div class="col-12">
              Supervision
            </div>
          </div>
        </div>
          <div class="row">
            <div class="col-12">
              <table class="table table-bordered table-sm mb-0">
                <tbody>
                  <tr>
                    <td style="width: 80%;">
                      <span tuiBadge size="l" appearance="primary"
                        class="so-view-info">J
                        <span class="custom-content"></span>
                      </span>
                    </td>
                    <td style="width: 10%; text-align: left;">
                      {{soView.superVisionPerc}} %
                    </td>
                    <td style="width: 10%; text-align: right;color: white; "
                      class="so-view-cell-summary">
                      $ {{soView.soSupervisionTotalAmount | number :'1.2-2'}}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
}
<div class="row mt-3">
  <div class="col-12">
    <div class="card shadow-sm border rounded-4 bg-body" size="s" class="pad-bottom-10">
      <div class="card-body pad-10">
          <div class="text-uppercase text-muted small fw-bold mb-2">
        <div class="row">
          <div class="col-12">
            Travel Lead
          </div>
        </div>
      </div>
        <div class="row">
          <div class="col-12">
            <table class="table table-bordered table-sm mb-0">
              <tbody>
                <tr>
                  <td style="width: 80%;">
                    <span tuiBadge size="l" appearance="primary"
                      class="so-view-info">K
                      <span class="custom-content"></span>
                    </span>
                  </td>
                  <td style="width: 10%;text-align: right;color: white;"
                  class="so-view-cell-summary">Travel Lead Total</td>
                  <td style="width: 10%; text-align: right;color: white; "
                    class="so-view-cell-summary">
                    $ {{soView.travelLeadCost | number :'1.2-2'}}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
@if (!soView.isPriceHide && !soView.isDiscountHide) {
  <div class="row mt-3">
    <div class="col-12">
      <div class="card shadow-sm border rounded-4 bg-body" size="s" class="pad-bottom-10">
        <div class="card-body pad-10">
            <div class="text-uppercase text-muted small fw-bold mb-2">
          <div class="row">
            <div class="col-12">
              Discount
            </div>
          </div>
        </div>
          <div class="row">
            <div class="col-12">
              <table class="table table-bordered table-sm mb-0">
                <tbody>
                  <tr>
                    <td style="width: 80%;">
                      <span tuiBadge size="l" appearance="primary"
                        class="so-view-info">L
                        <span class="custom-content"></span>
                      </span>
                    </td>
                    <td style="width: 10%; text-align: left;">
                      {{soView.discountPerc}} %
                    </td>
                    <td style="width: 10%; text-align: right;color: white; "
                      class="so-view-cell-summary">
                      $ {{soView.discountTotalAmount | number :'1.2-2'}}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
}
@if (!soView.isPriceHide) {
  <div class="row mt-3">
    <div class="col-12">
      <div class="card shadow-sm border rounded-4 bg-body" size="s" class="pad-bottom-10">
        <div class="card-body pad-10">
           <div class="text-uppercase text-muted small fw-bold mb-2">
          <div class="row">
            <div class="col-12">
              Grand Total
            </div>
          </div>
        </div>
          <div class="row">
            <div class="col-12">
              <table class="table table-bordered table-sm mb-0">
                <tbody>
                  <tr>
                    <td style="width: 80%; text-align: right;">
                      <span tuiBadge size="l" appearance="primary"
                        class="margin-right-5 estimate-info">D
                        <span class="custom-content"></span>
                      </span>
                      <!-- TODO: (Taiga UI migration) For colored icons, please use <img src="'name' | tuiIcon" alt="icon" /> -->
<span tuiAvatar="@tui.plus" 
                      class="estimate-info-plus-minus"></span>
                      <span tuiBadge size="l" appearance="primary"
                        class="margin-right-5 estimate-info">E
                        <span class="custom-content"></span>
                      </span>
                      <!-- TODO: (Taiga UI migration) For colored icons, please use <img src="'name' | tuiIcon" alt="icon" /> -->
<span tuiAvatar="@tui.plus" 
                      class="estimate-info-plus-minus"></span>
                      <span tuiBadge size="l" appearance="primary"
                        class="margin-right-5 estimate-info">F
                        <span class="custom-content"></span>
                      </span>
                      <!-- TODO: (Taiga UI migration) For colored icons, please use <img src="'name' | tuiIcon" alt="icon" /> -->
<span tuiAvatar="@tui.plus" 
                      class="estimate-info-plus-minus"></span>
                      <span tuiBadge size="l" appearance="primary"
                        class="margin-right-5 estimate-info">G
                        <span class="custom-content"></span>
                      </span>
                      <!-- TODO: (Taiga UI migration) For colored icons, please use <img src="'name' | tuiIcon" alt="icon" /> -->
<span tuiAvatar="@tui.plus" 
                      class="estimate-info-plus-minus"></span>
                      <span tuiBadge size="l" appearance="primary"
                        class="margin-right-5 estimate-info">H
                        <span class="custom-content"></span>
                      </span>
                      <!-- TODO: (Taiga UI migration) For colored icons, please use <img src="'name' | tuiIcon" alt="icon" /> -->
<span tuiAvatar="@tui.plus" 
                      class="estimate-info-plus-minus"></span>
                      <span tuiBadge size="l" appearance="primary"
                        class="margin-right-5 estimate-info">I
                        <span class="custom-content"></span>
                      </span>
                      <!-- TODO: (Taiga UI migration) For colored icons, please use <img src="'name' | tuiIcon" alt="icon" /> -->
<span tuiAvatar="@tui.plus" 
                      class="estimate-info-plus-minus"></span>
                      <span tuiBadge size="l" appearance="primary"
                        class="margin-right-5 estimate-info">J
                        <span class="custom-content"></span>
                      </span>
                      <!-- TODO: (Taiga UI migration) For colored icons, please use <img src="'name' | tuiIcon" alt="icon" /> -->
<span tuiAvatar="@tui.plus" 
                      class="estimate-info-plus-minus"></span>
                      <span tuiBadge size="l" appearance="primary"
                        class="margin-right-5 estimate-info">K
                        <span class="custom-content"></span>
                      </span>
                      @if (!soView.isDiscountHide) {
                        <!-- TODO: (Taiga UI migration) For colored icons, please use <img src="'name' | tuiIcon" alt="icon" /> -->
<span tuiAvatar="@tui.minus" 
                        class="estimate-info-plus-minus"></span>
                      }
                      @if (!soView.isDiscountHide) {
                        <span tuiBadge size="l" appearance="primary"
                          class="margin-right-5 estimate-info">L
                          <span class="custom-content"></span>
                        </span>
                      }
                    </td>
                    <td style="width: 10%; text-align: right;color: white;"
                      class="so-view-cell-summary">
                      $ {{soView.soGrandTotal | number :'1.2-2'}}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
}
@if (!soView.isPriceHide) {
  <div class="row mt-3">
    <div class="col-12">
      <div class="card shadow-sm border rounded-4 bg-body" size="s" class="pad-bottom-10">
        <div class="card-body pad-10">
          <div class="text-uppercase text-muted small fw-bold mb-2">
          <div class="row">
            <div class="col-12">
              Deposit
            </div>
          </div>
        </div>
          <div class="row">
            <div class="col-12">
              <table class="table table-bordered table-sm mb-0">
                <tbody>
                  <tr>
                    <td style="width: 80%;">
                      <span tuiBadge size="l" appearance="primary"
                        class="so-view-info">M
                        <span class="custom-content"></span>
                      </span>
                    </td>
                    <td style="width: 10%; text-align: left;">
                      {{soView.depositPerc}} %
                    </td>
                    <td style="width: 10%; text-align: right;color: white;"
                      class="so-view-cell-summary">
                      $ {{soView.soDepositTotalAmount | number :'1.2-2'}}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
}
@if (soView.soSpecialInstructionsWithGroup.length > 0) {
  <div class="row mt-3">
    <div class="col-12">
      <div class="card shadow-sm border rounded-4 bg-body" size="s" class="pad-bottom-10">
        <div class="card-body pad-10">
           <div class="text-uppercase text-muted small fw-bold mb-2">
          <div class="row">
            <div class="col-12">
              Special Instructions
            </div>
          </div>
        </div>
          <div class="row">
            @if (soView.soSpecialInstructionsWithGroup.length === 0) {
              <div clsas="col-12">
                <span tuiBadge appearance="negative">{{ NATEXT }}</span>
              </div>
            }
            @for (spInstruction of soView.soSpecialInstructionsWithGroup; track spInstruction) {
              <div class="col-12"
                >
                <table class="table table-bordered table-sm mb-0">
                  <tbody>
                    <tr>
                      <td style="width: 100%; padding: .5rem 1rem;" class="bg-secondary">
                        {{spInstruction.specialInstCategoryDisplayName}}
                      </td>
                      <!-- <td style="width: 5%;" *ngIf="checkActionPermission(SETUP_UPDATE)">
                      <a class="msr-2 h-auto tblEditBtn"
                        ngbTooltip="Update Category"
                        (click)="openSpecialInstCatDisplayUpdateDialog(spInstruction)">
                        <i class="fas fa-pen"></i>
                      </a>
                    </td> -->
                  </tr>
                  @for (spItem of spInstruction.soSpecialInstructions; track spItem) {
                    <tr>
                      <td style="width: 100%; padding: .5rem 1rem;">
                        {{spItem.instructionNote}}
                      </td>
                      <!-- <td style="width: 5%;" *ngIf="checkActionPermission(SETUP_UPDATE)">
                      <a class="msr-2 h-auto tblEditBtn" ngbTooltip="Update Note"
                        (click)="openSpecialInstNoteUpdateDialog(spItem)">
                        <i class="fas fa-pen"></i>
                      </a>
                    </td> -->
                  </tr>
                }
              </tbody>
            </table>
          </div>
        }
      </div>
    </div>
  </div>
</div>
</div>
}
@if (soView.soBoothElementInstructionsGroup.length > 0) {
  <div class="row mt-3">
    <div class="col-12">
      <div class="card shadow-sm border rounded-4 bg-body" size="s" class="pad-bottom-10">
        <div class="card-body pad-10">
           <div class="text-uppercase text-muted small fw-bold mb-2">
          <div class="row">
            <div class="col-12">
              Booth Element Instructions
            </div>
          </div>
        </div>
          <div class="row g-3">
            @if (soView.soBoothElementInstructionsGroup.length === 0) {
              <div clsas="col-12">
                <span tuiBadge appearance="negative">{{ NATEXT }}</span>
              </div>
            }
            <div class="row g-3">
              @for (spGroupItem of soView.soBoothElementInstructionsGroup; track spGroupItem; let i = $index) {
                <!-- 4 columns on lg+, 2 columns on md, 1 on mobile -->
                <div class="col-12">
                  <div class="list-group shadow-sm">
                    <!-- Group header -->
                    <div class="list-group-item bg-secondary fw-semibold">
                      {{ spGroupItem.elementDisplayName }}
                    </div>
                    <!-- Group items -->
                    @for (item of spGroupItem.soBoothElementInstructions; track item) {
                      <div
                        class="list-group-item"
                        >
                        {{ item.elementNote }}
                      </div>
                    }
                    <!-- Optional empty state if no notes -->
                    @if (!spGroupItem.soBoothElementInstructions?.length) {
                      <div
                        class="list-group-item text-muted fst-italic"
                        >
                        No instructions
                      </div>
                    }
                  </div>
                </div>
              }
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
}
@if ($safeNavigationMigration(soView.soInboundFreight?.carrierName)!==null) {
  <div class="row mt-3">
    <div class="col-12">
      <div class="card shadow-sm border rounded-4 bg-body" size="s" class="pad-bottom-10">
        <div class="text-uppercase text-muted small fw-bold mb-2">
          <div class="row">
            <div class="col-12">
              <table class="table table-bordered table-sm mb-0">
                <tbody>
                  <tr>
                    <th style="width: 100%; color: white;"
                      class="bg-positive pad-10">
                      Inbound Freight
                    </th>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        @if ($safeNavigationMigration(soView.soInboundFreight?.carrierName)===null) {
          <div clsas="col-12">
            <span tuiBadge appearance="negative">{{ NATEXT }}</span>
          </div>
        }
        <div class="card-text text-secondary ">
          <div class="row">
            <div class="col-12">
              @if (soView.soInboundFreight.carrierName!==null) {
                <table class="table table-bordered table-sm"
                  >
                  <tbody>
                    <tr>
                      <td style="width: 25%;" class="bg-secondary">
                        Carrier Name
                      </td>
                      <td style="width: 25%;">
                        {{soView.soInboundFreight.carrierName}}
                      </td>
                      <td style="width: 25%;" class="bg-secondary">
                        Primary Phone
                      </td>
                      <td style="width: 25%;">
                        @if (soView.soInboundFreight.primaryPhoneNumber) {
                          <span>
                            {{soView.soInboundFreight.primaryPhoneNumber |
                            phoneFormat:
                            getDialCode(soView.soInboundFreight.primaryPhoneNumberDialCode):'(###)
                            ###-####'}}
                          </span>
                        }
                        @if (getDataIfNotNull(soView.soInboundFreight.primaryPhoneNumberExt)) {
                          <strong class="pad-left-10"
                            >
                            Ext: {{soView.soInboundFreight.primaryPhoneNumberExt}}
                          </strong>
                        }
                      </td>
                    </tr>
                    <tr>
                      <td style="width: 25%;" class="bg-secondary">
                        Pickup Contact
                      </td>
                      <td style="width: 25%;">
                        {{soView.soInboundFreight.pickupContactPerson}}
                      </td>
                      <td style="width: 25%;" class="bg-secondary">
                        Secondary Phone
                      </td>
                      <td style="width: 25%;">
                        @if (soView.soInboundFreight.secondaryPhoneNumber) {
                          <span>
                            {{soView.soInboundFreight.secondaryPhoneNumber |
                            phoneFormat:
                            getDialCode(soView.soInboundFreight.secondaryPhoneNumberDialCode):'(###)
                            ###-####'}}
                          </span>
                        }
                        @if (getDataIfNotNull(soView.soInboundFreight.secondaryPhoneNumberExt)) {
                          <strong class="pad-left-10"
                            >
                            Ext: {{soView.soInboundFreight.secondaryPhoneNumberExt}}
                          </strong>
                        }
                      </td>
                    </tr>
                    <tr>
                      <td style="width: 25%;" class="bg-secondary">
                        Pickup Date
                      </td>
                      <td style="width: 25%;">
                        @if (soView.soInboundFreight.deliveryDate) {
                          <span>
                            {{soView.soInboundFreight.deliveryDate | date:
                            DAY_NAME_MONTH_DAY_YEAR}}
                          </span>
                        }
                      </td>
                      <td style="width: 25%;" class="bg-secondary">
                        How will the freight will be shipped
                      </td>
                      <td style="width: 25%;">
                        @if (soView.soInboundFreight.isDirect) {
                          <span class="pad-right-10"
                          >Direct</span>
                        }
                        @if (soView.soInboundFreight.isAdvance) {
                          <span class="pad-right-10"
                          >Advance</span>
                        }
                        @if (soView.soInboundFreight.isUnknown) {
                          <span class="pad-right-10"
                          >Unknown</span>
                        }
                      </td>
                    </tr>
                  </tbody>
                </table>
              }
            </div>
          </div>
          @if (soView.soInboundFreight.inboundFreightNotes.length > 0) {
            <div class="row">
              <div class="col-12">
                <table class="table table-bordered table-sm">
                  <tbody>
                    <tr>
                      <th style="width: 100%; " class="bg-secondary">
                        Shipment Notes
                      </th>
                    </tr>
                    @for (item of soView.soInboundFreight.inboundFreightNotes; track item) {
                      <tr
                        >
                        <td style="width: 100%;">
                          {{item.shipmentNote}}
                        </td>
                      </tr>
                    }
                  </tbody>
                </table>
              </div>
            </div>
          }
          @if (soView.soInboundFreight.inboundFreightBills.length > 0) {
            <div class="row">
              <div class="col-12">
                <table class="table table-bordered table-sm">
                  <tbody>
                    <tr>
                      <th style="width: 100%; " class="bg-secondary">
                        Bill of Lading - Attachments
                      </th>
                    </tr>
                    @for (item of soView.soInboundFreight.inboundFreightBills; track item) {
                      <tr
                        >
                        <td style="width: 100%;">
                          <a class="primary-color cursor-pointer"
                            (click)="downloadInboundFile(item.soPrepareInboundFreightBillId, item.billFileName)"
                            ngbTooltip="Download Bill">
                            {{item.billFileName}}
                          </a>
                        </td>
                      </tr>
                    }
                  </tbody>
                </table>
              </div>
            </div>
          }
        </div>
      </div>
    </div>
  </div>
}
@if (soView.soOutboundFreight) {
  <div class="row mt-3">
    <div class="col-12">
      <div class="card shadow-sm border rounded-4 bg-body" size="s" class="pad-bottom-10">
        <div class="text-uppercase text-muted small fw-bold mb-2">
          <div class="row">
            <div class="col-12">
              <table class="table table-bordered table-sm mb-0">
                <tbody>
                  <tr>
                    <th style="width: 70%; color: white;" class="bg-error pad-10">
                      Outbound Freight
                    </th>
                    <th style="width: 30%; color: white;" class="bg-error pad-10">
                      Split Shipment : @if (soView.soOutboundFreight.isSplitShipment) {
                      <span
                      >Yes</span>
                    }
                    @if (!soView.soOutboundFreight.isSplitShipment) {
                      <span
                      >No</span>
                    }
                  </th>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div class="card-text text-secondary ">
        @if (soView.soOutboundFreight && soView.soOutboundFreight.outboundFreightShipments.length > 0) {
          <div
            >
            @for (itemOutbound of soView.soOutboundFreight.outboundFreightShipments; track itemOutbound; let i = $index) {
              <div class="mb-3"
                >
                <div class="card shadow-sm border rounded-4 bg-body" size="s" class="pad-bottom-10">
                  <div class="text-uppercase text-muted small fw-bold mb-2">
                    <div class="text-uppercase text-muted small fw-bold mb-2">
                      <div class="row">
                        <div class="col-12">
                          Shipment {{i+1}}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="card-text text-secondary ">
                    <div class="row">
                      <div class="col-12">
                        <table class="table table-bordered table-sm">
                          <tbody>
                            <tr>
                              <td style="width: 25%;" class="bg-secondary">
                                Carrier Name
                              </td>
                              <td style="width: 25%;">
                                {{itemOutbound.carrierName}}
                              </td>
                              <td style="width: 25%;" class="bg-secondary">
                                Primary Phone
                              </td>
                              <td style="width: 25%;">
                                @if (itemOutbound.primaryPhoneNumber) {
                                  <span
                                    >
                                    {{itemOutbound.primaryPhoneNumber |
                                    phoneFormat:
                                    getDialCode(itemOutbound.primaryPhoneNumberDialCode):'(###)
                                    ###-####'}}
                                  </span>
                                }
                                @if (getDataIfNotNull(itemOutbound.primaryPhoneNumberExt)) {
                                  <strong class="pad-left-10"
                                    >
                                    Ext:
                                    {{itemOutbound.primaryPhoneNumberExt}}
                                  </strong>
                                }
                              </td>
                            </tr>
                            <tr>
                              <td style="width: 25%;" class="bg-secondary">
                                Carrier Contact
                              </td>
                              <td style="width: 25%;">
                                {{itemOutbound.carrierContactPerson}}
                              </td>
                              <td style="width: 25%;" class="bg-secondary">
                                Secondary Phone
                              </td>
                              <td style="width: 25%;">
                                @if (itemOutbound.secondaryPhoneNumber) {
                                  <span
                                    >
                                    {{itemOutbound.secondaryPhoneNumber |
                                    phoneFormat:
                                    getDialCode(itemOutbound.secondaryPhoneNumberDialCode):'(###)
                                    ###-####'}}
                                  </span>
                                }
                                @if (getDataIfNotNull(itemOutbound.secondaryPhoneNumberExt)) {
                                  <strong class="pad-left-10"
                                    >
                                    Ext:
                                    {{itemOutbound.secondaryPhoneNumberExt}}
                                  </strong>
                                }
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                    @if (itemOutbound.outboundFreightAddresses.length > 0) {
                      <div class="row"
                        >
                        <div class="col-12">
                          <table class="table table-bordered table-sm">
                            <tbody>
                              <tr>
                                <th style="width: 100%; " class="bg-secondary">
                                  Addresses
                                </th>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    }
                    @if (itemOutbound.outboundFreightAddresses.length > 0) {
                      <div class="row"
                        >
                        @for (item of itemOutbound.outboundFreightAddresses; track item) {
                          <div class="col-4 mb-2"
                            >
                            <div class="card shadow-sm border rounded-4 bg-body" size="s" class="pad-bottom-10">
                              <div class="text-uppercase text-muted small fw-bold mb-2">
                                <div class="row">
                                  <div class="col-8">
                                    {{getAddressCategory(item.addressCategoryKey)}}
                                  </div>
                                </div>
                              </div>
                              <div
                                class="card-text text-secondary ">
                                <div class="row">
                                  <div
                                    class="col-5 primary-color tui-text_body">
                                    Ship To Location:
                                  </div>
                                  <div class="col-7 tui-text_body">
                                    {{item.shipToLocation}}
                                  </div>
                                </div>
                                <div class="row">
                                  <div
                                    class="col-5 primary-color tui-text_body">
                                    Attention:
                                  </div>
                                  <div class="col-7 tui-text_body">
                                    {{item.attention}}
                                  </div>
                                </div>
                                <div class="mt-2 tui-text_body">
                                  {{item.street}}
                                </div>
                                <div class="mt-1 tui-text_body">
                                  {{item.cityName}}, {{item.stateName}}
                                  {{item.zipCode}}
                                </div>
                                <div class="mt-1 tui-text_body">
                                  {{item.countryName}}
                                </div>
                              </div>
                            </div>
                          </div>
                        }
                      </div>
                    }
                    <div class="row">
                      <div class="col-12">
                        <table class="table table-bordered table-sm">
                          <tbody>
                            <tr>
                              <th style="width: 100%; " class="bg-secondary">
                                Shipment Notes
                              </th>
                            </tr>
                            @for (item of itemOutbound.outboundFreightNotes; track item) {
                              <tr
                                >
                                <td style="width: 100%;">
                                  {{item.shipmentNote}}
                                </td>
                              </tr>
                            }
                          </tbody>
                        </table>
                      </div>
                    </div>
                    @if (itemOutbound.outboundFreightBills.length > 0) {
                      <div class="row"
                        >
                        <div class="col-12">
                          <table class="table table-bordered table-sm">
                            <tbody>
                              <tr>
                                <th style="width: 100%; " class="bg-secondary">
                                  Bill of Lading - Attachments
                                </th>
                              </tr>
                              @for (item of itemOutbound.outboundFreightBills; track item) {
                                <tr
                                  >
                                  <td style="width: 100%;">
                                    <a class="primary-color cursor-pointer"
                                      (click)="downloadOutboundFile(item.soPrepareOutboundFreightBillId, item.billFileName)"
                                      ngbTooltip="Download Bill">
                                      {{item.billFileName}}
                                    </a>
                                  </td>
                                </tr>
                              }
                            </tbody>
                          </table>
                        </div>
                      </div>
                    }
                  </div>
                </div>
              </div>
            }
          </div>
        }
      </div>
    </div>
  </div>
</div>
}
@if (soView.soBoothFiledFilesGroup.length !== 0) {
  <div class="row mt-3">
    <div class="col-12">
      <div class="card shadow-sm border rounded-4 bg-body" size="s" class="pad-bottom-10">
        <div class="text-uppercase text-muted small fw-bold mb-2">
          <div class="row">
            <div class="col-12">
              Booth Field Files
            </div>
          </div>
        </div>
        <div class="card-text text-secondary ">
          @if (soView.soBoothFiledFilesGroup.length === 0) {
            <div clsas="col-12">
              <span tuiBadge appearance="negative">{{ NATEXT }}</span>
            </div>
          }
          <div class="row g-3">
            @for (group of soView.soBoothFiledFilesGroup; track group; let i = $index) {
              <!-- 4 columns on lg+, 2 columns on md, 1 on mobile -->
              <div class="col-3">
                <div class="list-group shadow-sm">
                  <!-- Category header -->
                  <div class="list-group-item bg-secondary fw-semibold">
                    {{ group?.fileCategoryDisplayName }}
                  </div>
                  <!-- Files -->
                  @for (item of group?.soBoothFiledFiles; track item) {
                    <div class="list-group-item d-flex align-items-center m-0"
                      >
                      <div class="file-name-short">
                        <a class="primary-color cursor-pointer"
                          (click)="downloadBoothFile(item?.soScopeBoothFieldFileId || '', item?.fileName || '')">
                          {{ (getFileName($safeNavigationMigration(item?.fileName)) || '').trim() }}
                        </a>
                      </div>
                      <div class="file-ext ms-2">
                        <a class="primary-color cursor-pointer"
                          (click)="downloadBoothFile(item?.soScopeBoothFieldFileId || '', item?.fileName || '')">
                          {{ (item?.fileExtension || '').trim() }}
                        </a>
                      </div>
                    </div>
                  }
                  <!-- Optional empty state -->
                  @if (!group?.soBoothFiledFiles?.length) {
                    <div class="list-group-item text-muted fst-italic">
                      No files
                    </div>
                  }
                </div>
              </div>
            }
          </div>
        </div>
      </div>
    </div>
  </div>
}
<div class="row mt-3">
  <div class="col-12">
    <div class="card shadow-sm border rounded-4 bg-body" size="s" class="pad-bottom-10">
      <div class="text-uppercase text-muted small fw-bold mb-2">
        <div class="row">
          <div class="col-12">
            {{getCompanyName()}} Contact Information
          </div>
        </div>
      </div>
      <div class="card-text text-secondary ">
        <div class="row">
          <div class="col-12">
            <div class="list-group shadow-sm">
              <!-- Header -->
              <div class="list-group-item bg-secondary fw-semibold">
                Company Contacts
              </div>
              <!-- Column labels (desktop/tablet) -->
              <div class="list-group-item d-none d-md-block">
                <div class="row fw-semibold text-muted">
                  <div class="col-md-3">Name</div>
                  <div class="col-md-2">Role</div>
                  <div class="col-md-3">Contact Number</div>
                  <div class="col-md-4">Email Address</div>
                </div>
              </div>
              <!-- Rows -->
              @for (item of soView.soCompanyContactInformation; track item) {
                <div class="list-group-item">
                  <div class="row align-items-center">
                    <div class="col-12 col-md-3">
                      <div class="d-md-none text-muted small">Name</div>
                      <div class="fw-semibold">{{ item.name }}</div>
                    </div>
                    <div class="col-12 col-md-2 mt-2 mt-md-0">
                      <div class="d-md-none text-muted small">Role</div>
                      <div>{{ item.role }}</div>
                    </div>
                    <div class="col-12 col-md-3 mt-2 mt-md-0">
                      <div class="d-md-none text-muted small">Contact Number</div>
                      @if (item.contactNumber) {
                        <span>
                          <a [href]="'tel:' + item.contactNumber">
                            {{
                            item.contactNumber
                            | phoneFormat: getDialCode(item.contactNumberDialCode) : '(###) ###-####'
                            }}
                          </a>
                        </span>
                      } @else {
                        <span class="text-muted">—</span>
                      }
                    </div>
                    <div class="col-12 col-md-4 mt-2 mt-md-0">
                      <div class="d-md-none text-muted small">Email Address</div>
                      @if (item.emailAddress) {
                        <a [href]="'mailto:' + item.emailAddress">
                          {{ item.emailAddress }}
                        </a>
                      } @else {
                        <span class="text-muted">—</span>
                      }
                    </div>
                  </div>
                </div>
              }
              <!-- Empty state -->
              @if (!soView.soCompanyContactInformation?.length) {
                <div
                  class="list-group-item text-muted fst-italic"
                  >
                  No contacts available
                </div>
              }
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</div>
</div>
</div>
</div>
</section>
}